fx.ns("desktop.common.panels", class ChangeThemesPanel extends fx.Component {    
    
	constructor(data)
	{
		super(data);
		this.destroyOnSwitch = true;
		//this.listenUpdates(this.data);
	}

	create()
	{
        let box = new fx.components.Box();

		// Thematic name
		this.title = new fx.components.Text({text :fx.text("Thèmes")+" "+this.data.tag, className : "title center"});
		
		// Themes list
		box.addChild(this.title, {width:"100%", height : 40, top : 40, left : "center"});
		this.containerCategories = new fx.components.HBox("themes"); 
		this.containerCategories.visibleAtStart = false;
		this.containerCategories.effect = "fade";
		box.addChild(this.containerCategories, {width:"100%", height : "fill", top : 100, left : "center"});
		this.addChild(box, { width : "100%", height : "100%", top : 0, left : 0});
	}

    onReady()
    {
        super.onReady();
		this.loading(true, fx.text("Chargement"));
		this.on("click", this._onClick, this.containerCategories);
		this.data.themes.load( this.data, true ); 
    }

	onDataEvent(e)
    {
        if (e.type == "themes-loaded")
            this._themesLoaded();
    }

	// When themes are loaded , display them in the view
	_themesLoaded()
	{
		let themes = this.data.themes.getThemes(this.data);
		for (let i = 0; i < themes.length; i++)
		{
			let theme = themes.getItemAt(i);
			let thumb;
			switch(this.data.creation.shape_option){
				case "square":
					thumb = theme.thumb_square;
					break;
				case "landscape":
					thumb = theme.thumb_landscape;
					break;
				case "portrait":
					thumb = theme.thumb_portrait;
					break;
				default:
					thumb = theme.thumb_square;
					break;
			}
			let image = new fx.components.Image({data : thumb, className : "item"} );
			image.theme = theme;
			if (theme.id == this.data)
				image.addClass("selected");

            this.containerCategories.addChild( image, {width:this.data.creation.pageWidth/1.4, height : this.data.creation.pageHeight/1.4} );
		}
		this.containerCategories.show();
		this.loading(false);
	}

	// go to Change layouts view on next button click
    _onClick(event)
    {
		let target = this.getChildFromUI(fx.dom.parent(event.target, ".item"));
		if(target)
			this.trigger("next-step", target.theme);
    }

	close()
	{
		super.close();
		this.data.event("show-editor");
	}

});